import React, { useState } from 'react';

function SimplePriceFilter({ onFilterChange, minPrice = 0, maxPrice = 5000 }) {
  const [minPriceState, setMinPriceState] = useState(minPrice);
  const [maxPriceState, setMaxPriceState] = useState(maxPrice);

  const handleMinChange = (e) => {
    const value = parseInt(e.target.value);
    if (value <= maxPriceState) {
      setMinPriceState(value);
      onFilterChange(value, maxPriceState);
    }
  };

  const handleMaxChange = (e) => {
    const value = parseInt(e.target.value);
    if (value >= minPriceState) {
      setMaxPriceState(value);
      onFilterChange(minPriceState, value);
    }
  };

  return (
    <div style={{ 
      marginBottom: '20px',
      maxWidth: '300px'
    }}>
      <div style={{ fontWeight: '600', fontSize: '12px', marginBottom: '8px', color: '#555' }}>Price Range</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '12px', fontWeight: '600', color: '#000' }}>
        <span>Rs. {minPriceState}</span>
        <span>Rs. {maxPriceState}</span>
      </div>
      <div style={{ position: 'relative', height: '25px' }}>
        <input
          type="range"
          min={minPrice}
          max={maxPrice}
          step="100"
          value={maxPriceState}
          onChange={handleMaxChange}
          style={{
            position: 'absolute',
            width: '100%',
            height: '3px',
            WebkitAppearance: 'none',
            appearance: 'none',
            background: '#333',
            borderRadius: '2px',
            outline: 'none',
            zIndex: 1,
            pointerEvents: 'none'
          }}
        />
        <input
          type="range"
          min={minPrice}
          max={maxPrice}
          step="100"
          value={minPriceState}
          onChange={handleMinChange}
          style={{
            position: 'absolute',
            width: '100%',
            height: '3px',
            WebkitAppearance: 'none',
            appearance: 'none',
            background: 'transparent',
            borderRadius: '2px',
            outline: 'none',
            zIndex: 2,
            pointerEvents: 'none'
          }}
        />
      </div>
      <style>{`
        input[type="range"]::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          background: #000;
          border: 2px solid white;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
          pointer-events: auto;
          position: relative;
          z-index: 10;
        }
        input[type="range"]::-webkit-slider-thumb:hover {
          transform: scale(1.15);
        }
        input[type="range"]::-moz-range-thumb {
          width: 18px;
          height: 18px;
          background: #000;
          border: 2px solid white;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
          pointer-events: auto;
          position: relative;
          z-index: 10;
        }
        input[type="range"]::-moz-range-thumb:hover {
          transform: scale(1.15);
        }
      `}</style>
    </div>
  );
}

export default SimplePriceFilter;

